import { render, staticRenderFns } from "./EmailLogDrawer.vue?vue&type=template&id=20f9a13d"
import script from "./EmailLogDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailLogDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports